<template>
   <!-- ! Модальное окно заявки -->
   <div class="frame-modal-wrapper-bg service-request-modal-wrapper-bg" @click.self="closeServiceRequestModal">
      <div class="modal-dialog modal-dialog-centered" role="document">
         <div class="modal-content">
            <div class="modal-header ">
               <div class="modal-title h2">{{ $static('item.leave-request-m-title', 'Залиште вашу заявку') }}</div>
               <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                  @click="closeServiceRequestModal">
                  <img src="/images/icons/close.svg" alt="">
               </button>
            </div>
            <div class="modal-body" v-if="modalSettings">

               <div class="form-holder">
                  <!-- !  Основные поля модального окна заявки -->
                  <div class="form-group " v-if="modalSettings.name">
                     <input type="text" name="name" class="form-control custom-input"
                        :class="{ 'request-modal-error-input': modalErrors.basicFields.nameRequiredError }"
                        v-model="modal.name" :placeholder="$static('item.leave-request-name-placeholder', 'Ваше ім\'я')"
                        maxlength="80" @focus="resetModalErrors">
                     <p v-if="modalErrors.basicFields.nameRequiredError" class="request-modal-error">
                        {{ $static('item.leave-request-necess-field', 'Це поле обовязкове') }}
                     </p>
                  </div>

                  <div class="form-group phone-input" style="z-index:1111" v-if="modalSettings.phone">
                     <input type="tel" id="service-request-tel" class="form-control custom-input" v-model="modal.phone"
                        @focus="resetModalErrors"
                        :class="{ 'request-modal-error-input': modalErrors.basicFields.phoneRequiredError || modalErrors.basicFields.phoneFormatError }">


                     <p v-if="modalErrors.basicFields.phoneRequiredError" class="request-modal-error">
                        {{ $static('item.leave-request-necess-field', 'Це поле обовязкове') }}
                     </p>
                     <p v-if="modalErrors.basicFields.phoneFormatError" class="request-modal-error">
                        {{ $static('item.leave-request-uncorrect-phone', 'Некоректний телефон') }}
                     </p>
                  </div>

                  <div class="form-group " v-if="modalSettings.email">
                     <input type="text" name="email" class="form-control custom-input"
                        :class="{ 'request-modal-error-input': modalErrors.basicFields.emailRequiredError || modalErrors.basicFields.emailFormatError }"
                        v-model="modal.email" placeholder="Email" @focus="resetModalErrors">
                     <p v-if="modalErrors.basicFields.emailRequiredError" class="request-modal-error">
                        {{ $static('item.leave-request-necess-field', 'Це поле обовязкове') }}
                     </p>
                     <p v-if="modalErrors.basicFields.emailFormatError" class="request-modal-error">
                        {{ $static('item.leave-request-uncorrect-email', 'Некоректний email') }}
                     </p>
                  </div>

                  <div class="form-group datepicker" v-if="modalSettings.date">
                     <div class="form-group">
                        <label class="custom-label">{{ $static('item.leave-request-choose-date', 'Оберiть дату')
                           }}</label>
                        <div class="custom-input-group custom-calendar">
                           <v-date-picker mode="dateTime" is24hr v-model.number="dateFromPicker" :min-date='new Date()'
                              is-expanded is-required @update:modelValue="resetModalErrors"
                              :locale="datePickerLocale" />
                           <p v-if="modalErrors.basicFields.dateRequiredError" class="request-modal-error">
                              {{ $static('item.leave-request-choose-date', 'Оберiть дату') }}
                           </p>
                        </div>
                     </div>
                  </div>

                  <!-- !Поля оплаты -->
                  <!--? Для режима каталога поступила команда их убрать-->
                  <!-- <div class="payment-data">
              <div class="custom-label">Оберіть тип оплати</div>
              <div class="option-group"> -->
                  <!-- <div class="option-item active">
                  <div class='option-item-body'>
                    <input type="radio" name="payment-type" value="сash-on-delivery">
                  </div> -->
                  <!-- </div> -->
                  <!-- <div v-for="(paymentType, paymentTypeIdx) in paymentTypes" :key="paymentType + paymentTypeIdx"
                  class="option-item" :class="{ 'active': paymentType.value === modal.paymentType?.value }">
                  <label class="option-item-body"> {{ paymentType.label }}
                    <input type="radio" name="payment-type" :value="paymentType.value"
                      :checked="paymentType.value === modal.paymentType?.value"
                      @click="modal.paymentType = paymentType">
                  </label>
                </div> -->
                  <!--                <div class="option-item" v-for="(pay, index) in payment" :key="index" @click="order.pay_type = pay.id"-->
                  <!--                     :class="{ 'active': order.pay_type === pay.id }">-->
                  <!--                  <div class='option-item-body'>-->
                  <!--                    <p>{{ $dynamic(pay.manifest, pay.manifest.title, 'title') }}</p>-->
                  <!--                  </div>-->
                  <!--                </div>-->
                  <!-- </div>
            </div> -->
                  <!-- !  ---------------------------- -->

                  <!-- !  Дополнительные поля модального окна заявки -->
                  <template v-if="customFieldsData.length > 0">
                     <div class="custom-uploader" v-for="(field, index) in modalSettings.fields"
                        :key="field.name + index">

                        <template v-if="field.type === 'file' && field.enabled">
                           <ImageUploader v-model="customFieldsData[index].data" :manifest="field" :fieldIndex="index"
                              @fileUploaderError="handleFileUploaderError($event, index)"
                              @resetErrors="resetFileUploaderError(index)"
                              :resetFileInputPreview="resetFileInputPreview" />

                           <p v-if="field.type === 'file' && modalErrors.customFields[index]?.fileRequiredError"
                              class="request-modal-error">
                              {{ $static('item.leave-request-add-file', 'Додайте файл або зображення') }}
                           </p>

                           <p v-if="modalErrors.customFields[index]?.notAuthForUploadError && field.type === 'file'"
                              class="request-modal-error">
                              {{ $static('item.leave-request-nead-auth',
                                 'Для можливості завантажити файли або зображення необхідно авторизуватися') }}
                           </p>
                           <p v-if="modalErrors.customFields[index]?.filesUploadError && !modalErrors.customFields[index]?.tooBigFileError && !modalErrors.customFields[index]?.maxFilesError && !modalErrors.customFields[index]?.notAuthForUploadError"
                              class="request-modal-error">
                              {{ $static('item.leave-request-upload-error', 'Сталася помилка при завантаженнi.') }}
                           </p>
                           <p v-if="modalErrors.customFields[index]?.maxFilesError" class="request-modal-error">
                              {{ $static('item.leave-request-maxfiles-error', 'Перевищено максимальну кількість файлів')
                              }}</p>
                           <p v-if="modalErrors.customFields[index]?.tooBigFileError" class="request-modal-error">
                              {{ $static('item.leave-request-too-big-file', 'Файл занадто великий') }}</p>
                        </template>

                        <template v-else-if="field.type === 'text' && field.enabled">
                           <div class="form-group">
                              <p> {{ this.$dynamic(field, field.name, 'name') }}</p>
                              <textarea :name="name" class="form-control custom-input"
                                 :placeholder="$static('item.leave-request-text-field-placeholder', 'Напишiть що-небудь')"
                                 :class="{ 'request-modal-error-input': modalErrors.customFields[index]?.textRequiredError }"
                                 v-model="customFieldsData[index].data" @input="updateFieldValue($event, index, field)"
                                 @focus="resetModalErrors"></textarea>
                           </div>
                           <p v-if="modalErrors.customFields[index]?.textRequiredError" class="request-modal-error">
                              {{ $static('item.leave-request-necess-field', 'Це поле обовязкове') }}
                           </p>
                        </template>

                        <template v-else-if="field.type === 'number' && field.enabled">
                           <div class="form-group">
                              <p> {{ this.$dynamic(field, field.name, 'name') }}</p>
                              <input type="number" name="number" class="form-control custom-input"
                                 :placeholder="$static('item.leave-request-number-placeholder', 'Введiть число')"
                                 :class="{ 'request-modal-error-input': modalErrors.customFields[index]?.numberRequiredError }"
                                 v-model="customFieldsData[index].data" @input="updateFieldValue($event, index, field)"
                                 @focus="resetModalErrors">
                           </div>
                           <p v-if="modalErrors.customFields[index]?.numberRequiredError" class="request-modal-error">
                              {{ $static('item.leave-request-necess-field', 'Це поле обовязкове') }}
                           </p>
                        </template>
                     </div>
                  </template>

                  <div class="button-holder">
                     <p v-if="hasModalErrors" class="request-modal-error">
                        {{ $static('item.leave-request-error', 'Помилка') }}
                     </p>
                     <button class="default-btn send-lead-btn" @click="sendLead()" :disabled="hasModalErrors">
                        <span class="btn-text">{{ $static('item.leave-request', 'Залишити заявку') }}</span>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M4.82307 11.683C4.85955 11.6953 4.89637 11.704 4.93315 11.7094C4.97326 11.8036 5.02509 11.9256 5.08555 12.0682C5.23312 12.4162 5.43194 12.8869 5.63717 13.3779C6.05571 14.3793 6.47789 15.4116 6.57113 15.7071C6.68655 16.0724 6.80856 16.3207 6.94176 16.4902C7.01062 16.5779 7.09028 16.6545 7.18348 16.7124C7.2304 16.7416 7.27996 16.7655 7.33169 16.7834C7.33397 16.7841 7.33625 16.7849 7.33852 16.7857C7.6052 16.8864 7.84833 16.8444 8.00056 16.7931C8.08201 16.7657 8.14791 16.7325 8.19462 16.7057C8.21843 16.692 8.23855 16.6792 8.2546 16.6684L8.25839 16.6659L10.6136 15.1972L13.334 17.2828C13.3742 17.3136 13.418 17.3394 13.4643 17.3597C13.7912 17.5023 14.1076 17.552 14.4054 17.5113C14.7025 17.4708 14.9385 17.3459 15.1142 17.2054C15.2862 17.0677 15.4028 16.9136 15.4754 16.7991C15.5125 16.7406 15.5403 16.6889 15.56 16.6492C15.5698 16.6293 15.5778 16.6122 15.5839 16.5984L15.5918 16.5802L15.5947 16.5731L15.596 16.57L15.5965 16.5686L15.5971 16.5673C15.6113 16.5316 15.6223 16.4946 15.6298 16.4569L18.1133 3.9356C18.1213 3.89556 18.1253 3.85482 18.1253 3.81399C18.1253 3.44732 17.9871 3.09866 17.6622 2.88708C17.3846 2.70625 17.0753 2.69847 16.8798 2.7133C16.6689 2.72931 16.4742 2.78136 16.3435 2.82295C16.2755 2.8446 16.2184 2.86549 16.1773 2.88142C16.1567 2.88943 16.1397 2.89631 16.1271 2.90155L16.1176 2.90554L2.1895 8.36933L2.18769 8.36997C2.17882 8.3732 2.16742 8.37746 2.15388 8.38273C2.12691 8.39323 2.09077 8.40802 2.04856 8.42716C1.96624 8.46446 1.85076 8.52277 1.73225 8.60392C1.54293 8.73357 1.10752 9.08866 1.18084 9.67474C1.23933 10.1423 1.55965 10.4295 1.75481 10.5676C1.86196 10.6434 1.96377 10.6976 2.03791 10.7329C2.07231 10.7493 2.14372 10.7783 2.17471 10.7909L2.18253 10.7941L4.82307 11.683ZM16.6051 4.05654L16.6031 4.05738C16.5962 4.0604 16.5892 4.06329 16.5822 4.06605L2.63712 9.53647C2.62984 9.53933 2.62251 9.54204 2.61512 9.54462L2.60736 9.54756C2.59844 9.55103 2.58342 9.55714 2.56457 9.56568C2.55388 9.57053 2.54272 9.57581 2.53135 9.58149C2.54697 9.59029 2.56193 9.59793 2.57522 9.60426C2.58798 9.61033 2.59771 9.61449 2.60304 9.61667L5.22189 10.4983C5.26983 10.5145 5.31451 10.5359 5.35553 10.5616L14.0029 5.49954L14.011 5.49476C14.0173 5.49105 14.0255 5.48625 14.0355 5.48064C14.0551 5.46952 14.0822 5.45472 14.1143 5.43835C14.1744 5.4078 14.2704 5.36246 14.3785 5.32903C14.4539 5.30575 14.6759 5.24018 14.916 5.31718C15.0642 5.36471 15.2176 5.46687 15.3174 5.63996C15.3669 5.72595 15.3934 5.81233 15.4061 5.89141C15.4401 6.01598 15.4348 6.13899 15.4082 6.24519C15.3509 6.47394 15.1901 6.65238 15.0439 6.78886C14.9186 6.90587 13.2974 8.46908 11.6982 10.0122C10.9006 10.7818 10.1112 11.5437 9.52113 12.1133L9.13359 12.4874L14.0269 16.2389C14.1391 16.2791 14.2055 16.277 14.2362 16.2729C14.2727 16.2679 14.3027 16.2538 14.3332 16.2293C14.3674 16.202 14.3973 16.165 14.4197 16.1298L14.4206 16.1283L16.8293 3.98416C16.7936 3.99275 16.7574 4.00299 16.7226 4.01408C16.6831 4.02664 16.6506 4.03859 16.629 4.04695C16.6184 4.05109 16.6107 4.05424 16.6065 4.05597L16.6051 4.05654ZM9.55398 14.3848L8.57774 13.6363L8.34119 15.1411L9.55398 14.3848ZM7.68217 12.1512L8.65298 11.2139C9.24306 10.6443 10.0326 9.88231 10.8302 9.11269L11.6406 8.33081L6.20723 11.5115L6.23638 11.5802C6.38447 11.9295 6.58418 12.4023 6.7905 12.8959C6.94477 13.265 7.10609 13.6537 7.25303 14.0135L7.48889 12.5132C7.51163 12.3685 7.5823 12.2433 7.68217 12.1512Z"
                              fill="white" />
                        </svg>
                     </button>
                  </div>

               </div>
            </div>
         </div>
      </div>
   </div>

   <!--! Модальное окно сообщения о статусе отправки заявки -->
   <div class="frame-modal-wrapper-bg service-request-status-modal-wrapper-bg" :class="{ 'is-visible': isReviewSent }"
      @click.self="closeModalAfterReviewSend">
      <section class="review-after-send-modal">
         <svg class="close-modal-btn close-modal-btn__review-after-send-modal" width="20" height="20"
            viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" @click.self="closeModalAfterReviewSend">
            <path d="M15 5L5 15" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5 5L15 15" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
         </svg>
         <div class="review-after-send-modal__content-wrapper" v-if="isReviewSentSuccessfully">
            <div class="after-send-icon">
               <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_4148_4833)">
                     <path
                        d="M10.6804 22.4145C9.74325 22.4145 8.86209 22.0495 8.19939 21.3869C7.93223 21.1197 7.93223 20.6866 8.19939 20.4193C8.46655 20.1523 8.89972 20.1523 9.16693 20.4193C9.5712 20.8237 10.1088 21.0463 10.6805 21.0463C11.2522 21.0463 11.7897 20.8237 12.194 20.4193L24.0068 8.60663C24.4111 8.20236 24.6337 7.66479 24.6337 7.09309C24.6337 6.5214 24.4111 5.98388 24.0068 5.57961C23.1721 4.74491 21.8142 4.74496 20.9797 5.57956L14.3984 12.1609C14.1312 12.4279 13.6982 12.4279 13.4309 12.1609C13.1637 11.8937 13.1637 11.4605 13.4309 11.1933L20.0122 4.61192C21.3803 3.24402 23.6061 3.24387 24.9743 4.61192C26.3424 5.98002 26.3424 8.20602 24.9743 9.57407L13.1615 21.3869C12.4988 22.0496 11.6177 22.4145 10.6804 22.4145Z"
                        fill="#14F9A7" />
                     <path
                        d="M14.6241 18.855L12.6268 20.8523C11.5237 21.9553 9.73528 21.9553 8.63221 20.8523L1.50992 13.7301C0.406849 12.627 0.406849 10.8386 1.50992 9.73551C2.61299 8.63244 4.40141 8.63244 5.50448 9.73551L14.6241 18.855Z"
                        fill="#14F9A7" />
                     <path
                        d="M10.2428 14.1967L12.4438 16.4145C13.6594 17.6394 14.1484 18.952 15.364 17.7271L24.6947 8.50576C25.9103 7.28086 25.9103 5.29493 24.6947 4.07004C23.4791 2.84514 21.5083 2.84514 20.2927 4.07004L10.2428 14.1967Z"
                        fill="#14F9A7" />
                     <path
                        d="M10.6293 22.3633C9.69203 22.3633 8.81097 21.9983 8.14827 21.3357L1.02604 14.2134C-0.342012 12.8453 -0.342012 10.6193 1.02604 9.25124C1.68884 8.58855 2.56989 8.22363 3.50706 8.22363C4.44433 8.22363 5.32539 8.5886 5.98809 9.25124L15.1077 18.3708C15.3748 18.638 15.3748 19.0711 15.1077 19.3383L13.1104 21.3356C12.4476 21.9983 11.5665 22.3633 10.6293 22.3633ZM3.50706 9.59189C2.93536 9.59189 2.39784 9.81451 1.99352 10.2188C1.15898 11.0534 1.15898 12.4114 1.99352 13.246L9.11576 20.3681C9.52003 20.7724 10.0575 20.995 10.6293 20.995C11.201 20.995 11.7385 20.7724 12.1428 20.3681L13.6564 18.8546L5.02055 10.2188C4.61628 9.81451 4.07881 9.59189 3.50706 9.59189Z"
                        fill="#14F9A7" />
                  </g>
                  <defs>
                     <clipPath id="clip0_4148_4833">
                        <rect width="26" height="26" fill="white" />
                     </clipPath>
                  </defs>
               </svg>

            </div>
            <b>{{ $static('reviews.as-thanks', 'Дякую!') }}</b>
            <p>{{ $static('reviews.as-thanks-text', 'Ваша заявка надіслана і незабаром буде розглянута') }}</p>
         </div>
         <div class="review-after-send-modal__content-wrapper" v-else>
            <b class="send-modal-error">{{ $static('reviews.as-thanks-error', 'Помилка!') }}</b>
            <p>{{ $static('reviews.as-thanks-error-text', 'Заявка не була надіслана. Спробуйте ще раз.') }}</p>
         </div>
      </section>
   </div>
</template>

<script>
import ImageUploader from '@/components/ImageUploader';
import { fixBodyPadding } from '@/utils/fixBodyPadding';
import intlTelInput from 'intl-tel-input';

export default {
   name: 'ServiceRequestModal',
   components: { ImageUploader },
   props: ['settings', 'item'],

   data() {
      return {
         submiting: false,

         order: {
            count: 1,
            additionSelect: [],
            additionUSelect: []
         },

         modalErrors: {
            basicFields: {
               nameRequiredError: false,
               phoneRequiredError: false,
               phoneFormatError: false,
               emailRequiredError: false,
               emailFormatError: false,
               dateRequiredError: false
            },
            customFields: []
         },
         modal: {
            fields: [],
            name: '',
            phone: '',
            email: '',
            // date: ((new Date().getTime()) / 1000).toFixed(),
            date: undefined,
            // paymentType: { label: "Оплата карткою", value: "card-payment" }, Для режима каталога решили убрать выбор оплаты
         },

         // paymentTypes: [{ label: "Оплата карткою", value: "card-payment" }, { label: "Оплата при отриманні", value: "сash-on-delivery" }], Для режима каталога решили убрать выбор оплаты

         isReviewSent: false,
         isReviewSentSuccessfully: false,
         isReviewSending: false,
         resetFileInputPreview: false,

         dateFromPicker: undefined,
         customFieldsData: [],

         iti: undefined
      }
   },

   mounted() {
      this.getModalCustomFieldsSettings();

      // Инициализация intl-tel-input
      const telInput = document.querySelector("#service-request-tel");
      if (telInput) {
         this.iti = intlTelInput(telInput, {
            utilsScript: "/js/utils.js",
            customContainer: "phone-input",
            initialCountry: "auto",
            countryOrder: ['ua', 'pl'],
            allowDropdown: true,
            autoPlaceholder: "polite",
            formatOnDisplay: true,
            nationalMode: false,
            placeholderNumberType: "MOBILE",
            showFlags: true,
            separateDialCode: true,
            strictMode: true,
            validationNumberType: "MOBILE",
            geoIpLookup: callback => {
               fetch("https://ipapi.co/json")
                  .then(res => res.json())
                  .then(data => callback(data.country_code))
                  .catch(() => callback("ua"));
            }
         });
      }
   },

   computed: {
      isTelegram() {
         if (window.Telegram && window.Telegram?.WebApp && window.Telegram.WebApp.initData && window?.Telegram?.WebApp?.initData.length > 0) { return true }
         else { return false }
      },
      userInfo() {
         if (!this.isTelegram && this.$store.getters.getUserInfo) { return this.$store.getters.getUserInfo } else {
            return this.account?.telegram ? this.account?.telegram : this.account
         }
      },
      account() {
         return this.$store.getters.getAccount
      },

      modalSettings() {
         return this.settings?.modal ? this.settings.modal : {}
      },

      hasModalErrors() {
         for (const key in this.modalErrors.basicFields) {
            if (this.modalErrors.basicFields[key] === true) {
               return true;
            }
         }

         // Проверка пользовательских полей
         for (const customField of this.modalErrors.customFields) {
            for (const key in customField) {
               if (customField[key] === true) {
                  return true;
               }
            }
         }
         return false;
      },
      datePickerLocale() {
         const currentLang = localStorage.getItem('$lang').toLowerCase();

         if (currentLang && currentLang !== "" && currentLang !== "ua") {
            return currentLang
         }
         return "uk"
      }
   },

   watch: {
      dateFromPicker(newDate) {
         this.modal.date = (newDate.getTime() / 1000).toFixed();
      },

      customFieldsData: {
         handler(newValue) {
            newValue.forEach((field, fieldIdx) => {
               this.modal.fields[fieldIdx] = {
                  data: field.data,
                  manifest: this.modalSettings.fields[fieldIdx]
               };
            });
         },
         deep: true
      }
   },

   methods: {
      resetModalErrors() {
         // Сброс основных полей
         for (const key in this.modalErrors.basicFields) {
            this.modalErrors.basicFields[key] = false;
         }

         // Сброс пользовательских полей
         this.modalErrors.customFields.forEach(customField => {
            for (const key in customField) {
               customField[key] = false;
            }
         });
      },

      getModalCustomFieldsSettings() {
         this.customFieldsData = [];

         if (this.modalSettings.fields && this.modalSettings.fields.length) {

            this.modalSettings.fields.forEach((field) => {
               this.customFieldsData.push({ data: "", manifest: field });

               let tempObject = {};

               switch (field.type) {
                  case "file": {
                     if (field.isRequired) {
                        tempObject.fileRequiredError = false;
                     }
                     tempObject.maxFilesError = false;
                     tempObject.filesUploadError = false;
                     tempObject.notAuthForUploadError = false;
                     tempObject.tooBigFileError = false;
                     break;
                  }
                  case "text": {
                     if (field.isRequired) {
                        tempObject.textRequiredError = false;
                     }
                     break;
                  }
                  case "number": {
                     if (field.isRequired) {
                        tempObject.numberRequiredError = false;
                     }
                     break;
                  }
                  default: {
                     break
                  }
               }

               this.modalErrors.customFields.push(tempObject);

               tempObject = {};
            })
         }
      },

      openModalAfterReviewSent(status) {
         this.isReviewSent = true;
         fixBodyPadding();
         document.body.classList.add('no-scroll');

         if (status == 200) { this.isReviewSentSuccessfully = true; }
      },

      closeModalAfterReviewSend() {
         setTimeout(() => {
            this.isReviewSent = false;
         }, 300)

         fixBodyPadding();
         document.body.classList.remove('no-scroll');
      },

      handleFileUploaderError(errorType, index) {
         switch (errorType) {
            case "maxFilesError": {
               this.modalErrors.customFields[index].maxFilesError = true;
               break;
            }
            case "filesUploadError": {
               this.modalErrors.customFields[index].filesUploadError = true;
               break;
            }
            case "notAuthForUploadError": {
               this.modalErrors.customFields[index].notAuthForUploadError = true;
               break;
            }
            case "tooBigFileError": {
               this.modalErrors.customFields[index].tooBigFileError = true;
               break;
            }
         }
      },

      resetFileUploaderError(index) {
         for (const key in this.modalErrors.customFields[index]) {
            this.modalErrors.customFields[index][key] = false;
         }
      },

      resetModalData() {
         this.dateFromPicker = undefined;
         this.customFieldsData.forEach((field) => { field.data = "" });

         this.modal = {
            fields: [],
            name: '',
            phone: '',
            email: '',
            date: ((new Date().getTime()) / 1000).toFixed()
         }

         this.resetFileInputPreview = true;
         setTimeout(() => { this.resetFileInputPreview = false; }, 1)
      },
      closeServiceRequestModal() {
         fixBodyPadding();

         window.$('.service-request-modal-wrapper-bg').removeClass('is-visible');
         window.$('body').removeClass('no-scroll');

         this.resetModalData();
      },

      updateFieldValue(event, index, manifest) {
         this.modal.fields[index] = { data: event.target.value, manifest: manifest }
      },

      validateLead() {
         //  Валидация базовых полей
         // 1. Валидация имени
         if (this.modalSettings.name && this.modalSettings.name_require) {
            this.modalErrors.basicFields.nameRequiredError = this.modal.name ? false : true;
         }

         // 2. Валидация телефона
         if (this.modalSettings.phone && this.modalSettings.phone_require) {

            if (this.modal.phone.length === 0) {
               this.modalErrors.basicFields.phoneRequiredError = true;
            } else if (!this.iti.isValidNumber()) {
               this.modalErrors.basicFields.phoneFormatError = true;
            }
         }

         // 3. Валидация почты
         if (this.modalSettings.email && this.modalSettings.email_require) {
            const emailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (this.modal.email.length === 0) {
               this.modalErrors.basicFields.emailRequiredError = true;
            } else {
               this.modalErrors.basicFields.emailFormatError = !emailRegExp.test(this.modal.email);
            }
         }

         // 4. Валидация даты
         if (this.modalSettings.date && this.modalSettings.date_require) {
            this.modalErrors.basicFields.dateRequiredError = this.modal.date ? false : true;
         }

         //  Валидация пользовательских полей
         if (this.modalSettings.fields && this.modalSettings.fields.length > 0) {
            this.modalSettings.fields.forEach((field, fieldIndex) => {
               if (field.enabled && field.isRequired) {
                  switch (field.type) {
                     case 'text': {
                        if (this.customFieldsData[fieldIndex].data.length === 0) {
                           this.modalErrors.customFields[fieldIndex].textRequiredError = true;
                        } else {
                           this.modalErrors.customFields[fieldIndex].textRequiredError = false;
                        }
                        break;
                     }

                     case 'number': {
                        if (this.customFieldsData[fieldIndex].data.length === 0) {
                           this.modalErrors.customFields[fieldIndex].numberRequiredError = true;
                        } else {
                           this.modalErrors.customFields[fieldIndex].numberRequiredError = false;
                        }
                        break;
                     }
                     case 'file': {
                        if (this.customFieldsData[fieldIndex].data.length === 0) {
                           this.modalErrors.customFields[fieldIndex].fileRequiredError = true;
                        } else {
                           this.modalErrors.customFields[fieldIndex].fileRequiredError = false;
                        }
                        break;
                     }
                  }
               }

            });
         }

      },

      async sendLead(user) {
         if (this.submiting) {
            return
         }

         this.validateLead();

         if (this.hasModalErrors) {
            return
         }

         let item = JSON.parse(JSON.stringify(Object.assign({}, this.order, this.item)))
         let busked = [item].map(i => {
            return {
               id: i.id,
               count: i.count,
               add: i.additionSelect.map(i => i.id),
               u_select: i.additionUSelect
            }
         })

         let order;
         if (localStorage.getItem("utmParams")) {
            const utmParams = JSON.parse(localStorage.getItem("utmParams"))
            order = Object.assign({}, this.modal, { busked: busked }, { phone: this.iti.getNumber() }, utmParams);
         } else {
            order = Object.assign({}, this.modal, { busked: busked }, { phone: this.iti.getNumber() });
         }

         let headers = {};
         let initCache = localStorage.getItem('initData');
         try {
            if (user) {
               order.user = user
            }
            if (this.userInfo) {
               order.user = this.userInfo
            }
            if (initCache && initCache.length) {
               headers.initData = initCache;
            }
         } catch (err) {
            console.error(err);
            this.showError('', err.toString())
         }

         if (order.user === undefined || order.user === null) {
            delete order.user
         }

         try {
            this.submiting = true
            const resp = await fetch(
               '/public/lead',
               {
                  method: 'POST',
                  mode: 'cors',
                  body: JSON.stringify(Object.assign({}, order)),
                  headers: headers
               }
            )
            const data = await resp.json();

            this.submiting = false
            if (data.error) {
               window.$('#error').addClass('is-visible');
               return
            }
            // window.$('#thx').addClass('is-visible');
            // if (initCache) {
            //   setTimeout(() => {
            //     window.Telegram.WebApp.close();
            //   }, 1000);
            // }

            // if (data.link) {
            //   setTimeout(() => {
            //     window.location.href = data.link;
            //   }, 1000);
            // } else {
            //   setTimeout(() => {
            //     window.$('#thx').removeClass('is-visible');
            //     this.$router.push({ name: 'home' });
            //   }, 3000);
            // }
            (function ($) {
               'use strict';
               $('.close').click();
            })(window.$);

            this.resetModalData()
            this.openModalAfterReviewSent(resp.status);
            localStorage.removeItem("utmParams");
            setTimeout(() => {
               this.closeModalAfterReviewSend()
               this.$router.push({ name: 'CabinetLeadHistory' });
            }, 3000);
         } catch (err) {
            this.submiting = false
            console.error(err);
            // this.showError('', err.toString())
            // window.$('#thx').removeClass('is-visible');
            // window.$('#errorModal').removeClass('is-visible');
         }
      },
   }
}
</script>

<style lang="scss" scoped>
.request-modal-error {
   /*временный стиль, удалить */
   color: red;
}

.request-modal-error-input {
   /*временный стиль, удалить */
   border-color: red;
}

.send-lead-btn:disabled {
   /*временный стиль, удалить */
   opacity: 0.2;
}

.after-send-icon svg {
   display: block;
   margin: auto;
}

.send-lead-btn:disabled:hover {
   /*временный стиль, удалить */
   background-color: rgb(33, 33, 33);
}

/*--------after review sent modal*/
.review-after-send-modal {
   position: absolute;
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
   width: 281px;
   padding: 35px 49px;
   border-radius: 15px;
   background-color: #FFF;
   overflow: hidden;

   @media (min-width: 768px) {
      width: 351px;
      padding: 48px 51px;
   }
}

.close-modal-btn__review-after-send-modal {
   position: absolute;
   top: 12px;
   right: 12px;

   @media (min-width: 768px) {
      top: 14px;
      right: 14px;
   }
}

.review-after-send-modal__content-wrapper {


   & b {
      display: block;
      margin-bottom: 8px;
      color: #353535;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      text-align: center;

      &.send-modal-error {
         color: red;
      }

      @media (min-width: 768px) {
         font-size: 24px;
      }
   }

   & p {
      color: #171717;
      font-size: 12px;
      line-height: normal;
      text-align: center;

      @media(min-width: 768px) {
         font-size: 19px;
      }
   }
}

.service-request-modal-wrapper-bg {
   overflow-y: auto;
}

.modal-dialog.modal-dialog-centered {
   margin-bottom: 60px;
}

.button-holder {
   display: flex;
   justify-content: center;
}
</style>